import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'mc0100',
    ecrans: ['00-2']
});

